import dayjs from 'dayjs';

export const getTransformedDate = (date: Date, istoDate?: boolean) => {
  const ZERO_TIME = istoDate ? ' 23:59:59.999' : ' 00:00:00.000';
  return dayjs(date).isValid()
    ? dayjs(date).format('YYYY-MM-DD') + ZERO_TIME
    : '';
};

export const getTransformedDay = (date: Date) => {
  return dayjs(date).isValid() ? dayjs(date).format('YYYY-MM-DD') : '';
};
